import { gql } from 'urql';

const AdvanceScreenContent = gql`
  query AdvanceScreenContent {
    advanceScreensContent {
      linkingScreenContent {
        title
        description
        bullets
        content
        termsAndConditionsCopy
        subContent
      }
      marketingScreenContent {
        title
        bullets
        disclaimer {
          aboveContent
          belowContent
          link {
            url
            text
          }
          additionalContent
        }
      }
      pendingScreenContent {
        title
        description
      }
      throttledScreenContent {
        title
        description
      }
    }
  }
`;

export default AdvanceScreenContent;
